import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden" data-id="element-93">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-94" />

      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-96">
          <CTAButton href="https://suiza.kitonline.shop/cart/44708314710151:1" className="w-full mb-5" data-id="element-97">
            💪 JA! ICH WILL MEINE SKISAISON REVOLUTIONIEREN — JETZT STARTEN
          </CTAButton>

          <div className="flex justify-center gap-3 text-brand-gold font-bold text-xs sm:text-sm" data-id="element-98">
            <span data-id="element-99">⚡ Sofortiger Zugriff</span>
            <span data-id="element-100">•</span>
            <span data-id="element-101">🛡️ 7 Tage Garantie</span>
            <span data-id="element-102">•</span>
            <span data-id="element-103">💳 Einmalzahlung</span>
          </div>
        </motion.div>
      </div>
    </section>;
}